import type { ResendOfferResult, UndeliveredQuote } from "../../../backend-worker/src/quoteDebugTypes";

export type { ResendOfferResult, UndeliveredQuote };

// Same-origin Pages Functions (functions/admin-api), behind Cloudflare Access —
// deliberately NOT the public API worker, since these return customer data.
// Not available under `vite dev`; use the deployed admin or `wrangler pages dev`.
const BASE = "/admin-api/quotes";

async function parse<T>(res: Response): Promise<T> {
  if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
  return res.json() as Promise<T>;
}

export async function fetchUndelivered(): Promise<UndeliveredQuote[]> {
  return parse(await fetch(`${BASE}/undelivered`, { credentials: "same-origin", cache: "no-store" }));
}

/** Render the PDF if needed and EMAIL it to the customer; logs it in HubSpot. */
export async function resendOffer(id: string, productType?: string): Promise<ResendOfferResult> {
  return parse(
    await fetch(`${BASE}/${encodeURIComponent(id)}/resend-offer`, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ productType }),
    }),
  );
}
